function SimpleButton(props?: any) {
    return (<button {...props}>{props.children}</button>);
}
export default SimpleButton;
